"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerWrapper = exports.Header2025Wrapper = exports.Header2025MetaIcons = exports.DonateButtonWrapperTop = exports.ButtonsAndIcons = exports.Brand = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _zIndex = _interopRequireDefault(require("../../../theme/shared/zIndex"));
var _containers = _interopRequireDefault(require("../../../theme/shared/containers"));
require("./annoying.css");
const Header2025Wrapper = exports.Header2025Wrapper = _styledComponents.default.header.attrs(() => ({
  role: 'banner'
})).withConfig({
  displayName: "Header2025style__Header2025Wrapper",
  componentId: "sc-7gs40r-0"
})(["position:relative;background-color:", ";padding:0;height:75px;@media ", "{height:86px;}", ";"], _ref => {
  let {
    theme
  } = _ref;
  return theme.color('white');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.allBreakpoints('Nav');
}, _ref3 => {
  let {
    showBoxShadow
  } = _ref3;
  return showBoxShadow && (0, _styledComponents.css)(["box-shadow:0px 13px 15px 0 rgba(0,0,0,0.05);"]);
});
const InnerWrapper = exports.InnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Header2025style__InnerWrapper",
  componentId: "sc-7gs40r-1"
})(["display:flex;align-items:center;height:100%;padding:0 12px;cursor:pointer;max-width:", ";@media ", "{margin:0 auto;}"], _containers.default.large, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.allBreakpoints('Nav');
});
const Brand = exports.Brand = _styledComponents.default.div.withConfig({
  displayName: "Header2025style__Brand",
  componentId: "sc-7gs40r-2"
})(["", ";margin-right:auto;display:flex;align-items:center;a{border:0;color:transparent;margin-right:25px;img{width:100%;object-fit:contain;}:hover{border:0;}}@media ", "{margin-right:0}"], (0, _zIndex.default)('high'), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.allBreakpoints('Nav');
});
const DonateButtonWrapperTop = exports.DonateButtonWrapperTop = _styledComponents.default.div.withConfig({
  displayName: "Header2025style__DonateButtonWrapperTop",
  componentId: "sc-7gs40r-3"
})(["width:100px;display:flex;justify-content:center;margin-left:5px;height:2.8rem;a{width:100%;height:inherit;transition:width 0.4s cubic-bezier(0.5,1.5,0.5,0.80);&:hover,&:focus{width:100%;box-shadow:rgba(0,0,0,0.1) 0 0 20px 0;}}"]);
const Header2025MetaIcons = exports.Header2025MetaIcons = _styledComponents.default.div.withConfig({
  displayName: "Header2025style__Header2025MetaIcons",
  componentId: "sc-7gs40r-4"
})(["display:none;@media ", "{width:auto;align-items:center;> div{height:35px;width:auto;display:inline-block;> a{height:inherit;width:inherit;margin-right:6px;img{padding:5px 7px;height:inherit;width:inherit;}}}position:relative;display:flex;align-items:center;background-color:", ";margin-right:0px;right:0px;}@media ", "{> div > a{margin-right:20px;}}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.allBreakpoints('Nav');
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.color('white');
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.allBreakpoints('NavWide');
});
const ButtonsAndIcons = exports.ButtonsAndIcons = _styledComponents.default.div.withConfig({
  displayName: "Header2025style__ButtonsAndIcons",
  componentId: "sc-7gs40r-5"
})(["margin-left:auto;display:flex;"]);